// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + {"91":"fe83a34a54771e28","398":"f01521156b05f7ea","538":"d721a2cd222fc43f","631":"1095b173f51b5c52","983":"b7818c8708e0cc44"}[chunkId] + ".js";
};